<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ data.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <form class="form-container" #dialogForm="ngForm">
                <mat-form-field>
                    <mat-select data-select-attribute-name placeholder="Attribut à surcharger" [(value)]="attributeId" tabindex="1">
                        @for (attribute of data.attributes; track attribute) {
                            <mat-option data-select-listing-attribute-name-option [value]="attribute.id">
                                {{ attribute.header }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-select data-select-condition-name placeholder="Condition de la surcharge" [(value)]="overrideCondition" tabindex="2">
                        @for (condition of data.overrideConditions; track condition) {
                            <mat-option data-select-listing-attribute-name-option [value]="condition.value">
                                {{ condition.text }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onDismiss()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
    </mat-card-actions>
</mat-card>
